import { playStimulusAudio } from '../../../common/stimulus/stimulusButtonActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import {
    blockScreen,
    unblockScreen,
    activateNextButton,
    greyOutScreen,
    colorInScreen,
} from '../../../common/screen/screenActions';
import { narrateStart } from '../../../common/audio/audioActions';
import selectors from '../../../rootSelectors';
import {
    highlightPossibleResponse,
    resetSelectedIndex,
    selectPossibleResponse,
} from '../../../common/questions/questionsActions';
import { MODEL } from '../../../constants/assessmentItemType';
import { GENERAL_AUDIO_DELAY } from '../../../constants/time';
import WR_AUDIO_INSTRUCTIONS from '../../wrConstants';

export const playModelScript = (stimulusAudio, delay) => async dispatch => {
    await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.avatarStartModel));
    await dispatch(playStimulusAudio([stimulusAudio], delay));
    dispatch(highlightPossibleResponse(0));
    await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.avatarAnswers[0]));
    dispatch(highlightPossibleResponse(1));
    await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.avatarAnswers[1]));
    dispatch(highlightPossibleResponse(2));
    await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.avatarAnswers[2]));
    dispatch(resetSelectedIndex());
    await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.avatarInstructionModel));
    dispatch(unblockScreen());
};

export const narrateScreen = (stimulusAudio, delay = GENERAL_AUDIO_DELAY) => async dispatch => {
    dispatch(blockScreen());
    dispatch(greyOutScreen());
    dispatch(narrateStart());
    await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.avatarDirectionInstruction));
    dispatch(colorInScreen());
    dispatch(playModelScript(stimulusAudio, delay));
};

export const firstIncorrectResponse = index => dispatch => {
    dispatch(selectPossibleResponse(index));
    dispatch(resetSelectedIndex());
    dispatch(unblockScreen());
};

export const nextIncorrectResponse = () => dispatch => {
    dispatch(activateNextButton());
    dispatch(setAvatarInstructions(WR_AUDIO_INSTRUCTIONS.clickOk));
    dispatch(unblockScreen());
};

export const correctResponse = index => dispatch => {
    dispatch(selectPossibleResponse(index));
    dispatch(activateNextButton());
    dispatch(setAvatarInstructions(WR_AUDIO_INSTRUCTIONS.clickOk));
};

export const incorrectResponseClick = (
    index,
    correctResponseIndex,
    isFirstAttemptMade,
) => async dispatch => {
    dispatch(blockScreen());
    dispatch(highlightPossibleResponse(correctResponseIndex));
    await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.avatarInstructionModel, 0));
    dispatch(isFirstAttemptMade ? nextIncorrectResponse() : firstIncorrectResponse(index));
};

export const modelScreenResponseClick = index => (dispatch, getStore) => {
    const state = getStore();
    const isFirstAttemptMade = selectors.getIsFirstAttemptMade(state);
    const correctResponseIndex = selectors.getWRCorrectResponseIndex(state, MODEL);

    if (correctResponseIndex !== index) {
        return dispatch(incorrectResponseClick(index, correctResponseIndex, isFirstAttemptMade));
    }

    return dispatch(correctResponse(index));
};
